<div class="ticker" [ngClass]="{ 'blue-type': type === types.BLUE, 'black-type': type === types.BLACK }">
    <div class="text" *ngIf="text != null" [innerHtml]="text | markdownToSafeHTML"></div>
    <div class="close-button" (click)="onClose()"><img src="assets/close.svg" alt="close" /></div>
</div>
